import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import * as c3 from 'c3';
import * as d3 from 'd3';

@Component({
  selector: 'app-trend-chart',
  templateUrl: './trend-chart.component.html',
  styleUrls: ['./trend-chart.component.scss']
})
export class TrendChartComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() data;
  @Input() name;
  @Input() gsl;
  @ViewChild('chartContainer') chartContainer: ElementRef;

  chartSelector: any;
  public chartInstance: any;
  listData: any[] = [];
  names = [];
  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit() {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.disposeChart();
    this.draw(this.data);
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.data && changes.data.currentValue){
      this.updateChartData();
    }
  }

  ngAfterViewInit(){
    this.updateChartData();
  }

  private updateChartData(){
    if (this.data && Object.keys(this.data).length > 0 && this.data.constructor === Object) {
      this.names = Object.keys(this.data);
      if (this.chartContainer) {
        this.draw(this.data);
      }
    }
  }

  draw(data) {
    this.listData = [];
    const colors = ['#5081ae', '#2a5783', '#b9ddf1', '#7eaed3'];
    this.names.forEach(item => {
      const object = {
        name: item,
        value: data[item].v ? data[item].v : 0,
        title: data[item].n ? data[item].n : ''
      };
      this.listData.push(object);
    });
    if (this.chartContainer && this.chartContainer.nativeElement) {
      this.chartSelector = d3.select(this.chartContainer.nativeElement);
    }

    const defaultConfig = {
      data: {
        x: 'x',
        columns: [
          this.transformXaxis(),
          this.transformYaxis(this.listData)
        ],
        color: (color, d: any) => {
          return d.index ? colors[d.index] : colors[0];
        }
      },
      axis: {
        x: {
          show: false,
          type: 'timeseries',
          padding: {
            right: 1,
            left: 1,
          },
        },
        y: {
          show: false,
          padding: {
            top: 7,
            bottom: 7,
          },
          min: this.getMinMaxValue(this.listData.slice()),
        }
      },
      tooltip: {
        contents: (d, defaultTitleFormat, defaultValueFormat, color) => {
          let text;
          const gsl = this.gsl ? this.gsl : 0;
          text = `<div class="tool-tip">`;
          text += `<span class="text-center">` + this.listData[d[0].index].title + `</span></br>`;
          text += `<span> Parent Supplier Name/GSL: ` + '<span class="gslName">' + gsl + `</span></span></br>`;
          text += `<span> ` + d[0].id + ': ' + this.listData[d[0].index].value + `</span></br>`;

          return text + '</div>';
        }

      },
      size: {
        height: 45,
      },
      legend: {
        show: false
      },
      bindto: this.chartContainer?.nativeElement
    } as c3.ChartConfiguration;
    this.chartInstance = c3.generate(defaultConfig);
  }

  transformXaxis() {
    return ['x', 0, 10, 20, 30];
  }

  transformYaxis(data) {
    return [this.name].concat(data.map(item => item.value));
  }

  detectChanges() {
    this.cd.detectChanges();
  }

  private disposeChart() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
    this.chartSelector = null;
  }

  private getMinMaxValue(data) {
    const newList = data.sort((a, b) => a.value - b.value);
    const minValue = newList[0].value;
    return Math.abs(minValue) < 10 ? minValue - 1 : minValue < 0 ? minValue + minValue * 10 / 100 : minValue - minValue * 10 / 100;
  }

}
